import { render, staticRenderFns } from "./CmgAccountModalAccountLinks.vue?vue&type=template&id=396097c0&scoped=true&lang=pug&"
import script from "./cmg-account-modal-account-links.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal-account-links.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModalAccountLinks.vue?vue&type=style&index=0&id=396097c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396097c0",
  null
  
)

export default component.exports